module.exports = __webpack_public_path__ + "static/media/bg.e4ab60c2.png";